import colors from "styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";
export const multiSelectFloatingLabelStyles = new String(`.floating-label-wrapper.is-select{.floating-label{top:50%}&.has-value .floating-label,&.is-focused .floating-label{top:0;background-color:${colors[WHITE_COLOR_NAME]}}&.has-value .hp-multi-select-input .react-select__control{padding-top:4px}}`);
multiSelectFloatingLabelStyles.__hash = "1b2f884435b64f13";
